<template>
<div id="landing" ref="content">
    <RequestDownloadModal ref="downloadModal"></RequestDownloadModal>
    <main>
        <article>
            <section>
                <h1 class="product-name">SOS<span class="trademark">&reg;</span><span class="product-version">v3</span></h1>
                <h2>Keep Your Team on the Same Page at all Times</h2>
                <h3>Real-time Rounding &amp; Hand-off for Physician Residency Training</h3>
                <div class="videos-row">
                    <div class="landing-video">
                        <VideoJs :src="'video/sos-features.mp4'" :poster="'img/sos-features.png'" click-fullscreen></VideoJs>
                    </div>
                              <div class="landing-video">
                        <VideoJs :src="'video/kolkin-sos-mobile.mp4'" :poster="'img/kolkin-or.png'" click-fullscreen></VideoJs>
                    </div>
                </div>
                <div>

                    <!-- <a v-if="isWindows" :href="'/download/sos.msi?fingerprint=' + fingerprint" download
                        class="download-button" @click="downloaded = true" :disabled="downloaded">
                        Download for Windows
                    </a>
                    <a v-else-if="isMac" :href="'/download/sos.dmg?fingerprint=' + fingerprint" download
                        class="download-button" @click="downloaded = true" :disabled="downloaded">
                        Download for Mac
                    </a>
                    <button v-else @click="$router.push({ name: 'downloads' })" class="download-button">
                        Download
                    </button>
                    <router-link v-if="isMac || isWindows" :to="{ name: 'downloads' }">
                        All versions
                    </router-link> -->

                </div>
                <img src="@/assets/img/acslogo.png" title="American College of Surgeons">
                <img src="@/assets/img/fhir-logo.png" title="HL7 FHIR">

            </section>
        </article>

    </main>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import store from "@/store";
import BlogArticleResult from "@/components/blogArticle/BlogArticleResult";
import RequestDownloadModal from "@/components/base/RequestDownloadModal";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Platform from "platform";
import VideoJs from "@/components/base/VideoJs";

export default {

    name: "Kolkin",

    components: {
        BlogArticleResult,
        RequestDownloadModal,
        VideoJs
    },

    // beforeRouteEnter(to, from, next) {
    //     var params = {
    //         category: "",
    //         limit: 9,
    //         offset: 0
    //     }
    //     if (!to.params.category) {
    //         params.category = "All";
    //     } else {
    //         params.category = to.params.category;
    //     }
    //     store.dispatch("loadCategories").then(function (response) {
    //         store.dispatch("loadBlogArticles", params).then(function (response) {
    //             next();
    //         });
    //     });
    // },

    // beforeRouteUpdate(to, from, next) {
    //     this.query = "";
    //     this.offset = 0;
    //     var params = {
    //         category: "",
    //         limit: this.limit,
    //         offset: 0
    //     }
    //     if (!to.params.category) {
    //         params.category = "All";
    //     } else {
    //         params.category = to.params.category;
    //     }
    //     store.dispatch("loadBlogArticles", params).then(function () {
    //         next();
    //     });
    // },

    data() {
        return {
            fingerprint: "",
            isMac: false,
            isWindows: false,
            downloaded: false,
        }
    },

    created() {

        var temp = this;
        // Initialize an agent at application startup.
        FingerprintJS.load().then(function (fp) {
            fp.get().then(function (result) {
                var visitorId = result.visitorId
                temp.fingerprint = visitorId
            })
        }).catch(function (error) { })
        console.log(Platform)
        this.isMac = Platform.os.family.includes("OS X");
        this.isWindows = Platform.os.family.includes("Windows");
    },

    methods: {
        signinPurchase() {
            window.location = "/signin/buy-" + encodeURIComponent('SOS Physician');
        },
        signinDownload() {
            window.location = "/signin/downloads";
        },
        loadMore() {
            this.offset = this.offset + this.limit;
            var params = {
                category: "",
                search: this.query,
                limit: this.limit,
                offset: this.offset
            }
            if (!this.$route.params.category) {
                params.category = "All";
            } else {
                params.category = this.$route.params.category;
            }
            store.dispatch("loadMoreBlogArticles", params);
        },
        downloadRequest() {
            this.$refs.downloadModal.open()
        },
        downloadClick() {

        },
    },

    computed: {
        showLoadMore() {
            return this.blogArticles.length >= this.limit && this.blogArticles.length < this.blogArticleCount;
        },
        ...mapGetters(["user", "categories", "blogArticles", "blogArticleCount"])
    },

};
</script>
